
import 'reflect-metadata';
import 'zone.js';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
//import { enableProdMode } from '@angular/core';

//import  './assets/css/style-newlogin.css';
//import  './assets/css/styles.css';
import './rxjs-operators.ts';
import './polyfills.js';
import '../node_modules/reflect-metadata';
import '../node_modules/zone.js';

//declare var require:any;

//testar removendo a linha debaixo
import '../node_modules/es6-shim/es6-shim.min.js';

//import './login/login.component.css';
import 'hammerjs';
import { enableProdMode } from '@angular/core';
declare var process: any;

if (process.env.NODE_ENV === 'production') {
    //console.log("PRODUCTION MODE");
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).then(ref => {
  // if (window['ngRef']) {
  //   window['ngRef'].destroy();
  // }
  // window['ngRef'] = ref;
}).catch(err => console.error(err));


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/main.ts